import moment from 'moment';
import { v4 as uuid4 } from 'uuid';
import { events } from '../../test.data';
import { EventItem } from '../../types/event.type';
import {
  convertDateToX,
  groupByDate,
  occursInThis,
} from '../../utils/common.util';
import EventCard from '../cards/v2/event.card';
import { VStack } from '../layouts/stack.layout';
import Text from '../typography/v2/text';
import Container from './container';

type EventsQuery = 'ALL' | 'THIS_WEEK' | 'THIS_MONTH' | 'COMING_SOON';

type Props = {
  trigger: Function;
  query: EventsQuery[];
};

export default function EventsContainer(props: Props) {
  const { trigger, query } = props;

  const data: EventItem[] = [];

  // temporary data querying from local data store
  if (query) {
    for (const q of query) {
      data.push(...GET[q]());
    }
  }

  const groupedEvents = groupByDate<EventItem>(data);

  const dates = Object.keys(groupedEvents).sort(
    (a: string, b: string) => convertDateToX(a, 'll') - convertDateToX(b, 'll')
  );

  return (
    <>
      {dates.map((date) => (
        <section className="my-2 mobile:px-2 tablet-lg:px-[40px]" key={uuid4()}>
          <Container extensions="grid grid-cols-sm mobile:gap-x-3 tablet-sm:gap-5">
            <Container>
              <Container extensions="sticky top-0">
                <VStack align="start" extensions="w-full">
                  <Text variant="month">{moment(date).format('MMM')}</Text>
                  <Text variant="day">{moment(date).format('D')}</Text>
                </VStack>
              </Container>
            </Container>
            <Container extensions="grid tablet-lg:grid-cols-2 gap-7">
              {groupedEvents[date].map((event: EventItem) => (
                <EventCard key={uuid4()} onClick={trigger} data={event} />
              ))}
            </Container>
          </Container>
        </section>
      ))}
    </>
  );
}

type EventQueryMap = { [key in EventsQuery]: Function };

const GET: EventQueryMap = {
  ALL: (): EventItem[] => {
    return events;
  },

  COMING_SOON: (): EventItem[] => {
    return events.filter(
      (event) =>
        convertDateToX(event.date, 'll') >
        parseInt(moment().endOf('month').format('x'))
    );
  },
  THIS_MONTH: (): EventItem[] => {
    return events.filter((event) => occursInThis('month', event.date));
  },
  THIS_WEEK: (): EventItem[] => {
    return events.filter((event) => occursInThis('week', event.date));
  },
};
